// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { ExtEnrollmentCardInfoModel } from './extEnrollmentCardInfoModel.js';
import type { ExtEnrollmentGuardianInfoModel } from './extEnrollmentGuardianInfoModel.js';
import type { ExtEnrollmentMedBenClientIdentifiersModel } from './extEnrollmentMedBenClientIdentifiersModel.js';
import type { ExtEnrollmentMedBenEnrollmentDemographicsModel } from './extEnrollmentMedBenEnrollmentDemographicsModel.js';
import type { ExtEnrollmentMedBenInsuranceVerificationModel } from './extEnrollmentMedBenInsuranceVerificationModel.js';
import type { ExtEnrollmentSurveyQuestionModel } from './extEnrollmentSurveyQuestionModel.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class ExtEnrollmentHybridEnrollmentRequestModel {
    'cardInfo'?: ExtEnrollmentCardInfoModel | null;
    'insuranceVerification'?: ExtEnrollmentMedBenInsuranceVerificationModel | null;
    'survey': Array<ExtEnrollmentSurveyQuestionModel>;
    'clientIdentifiers'?: ExtEnrollmentMedBenClientIdentifiersModel | null;
    'demographics'?: ExtEnrollmentMedBenEnrollmentDemographicsModel | null;
    'guardianInfo'?: ExtEnrollmentGuardianInfoModel | null;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof ExtEnrollmentHybridEnrollmentRequestModel>> = [
        {
            "name":     "cardInfo",
            "baseName": "cardInfo",
            "type":     "ExtEnrollmentCardInfoModel"
        },
        {
            "name":     "insuranceVerification",
            "baseName": "insuranceVerification",
            "type":     "ExtEnrollmentMedBenInsuranceVerificationModel"
        },
        {
            "name":     "survey",
            "baseName": "survey",
            "type":     "Array<ExtEnrollmentSurveyQuestionModel>"
        },
        {
            "name":     "clientIdentifiers",
            "baseName": "clientIdentifiers",
            "type":     "ExtEnrollmentMedBenClientIdentifiersModel"
        },
        {
            "name":     "demographics",
            "baseName": "demographics",
            "type":     "ExtEnrollmentMedBenEnrollmentDemographicsModel"
        },
        {
            "name":     "guardianInfo",
            "baseName": "guardianInfo",
            "type":     "ExtEnrollmentGuardianInfoModel"
        },
    ];

    static getAttributeTypeMap() {
        return ExtEnrollmentHybridEnrollmentRequestModel.attributeTypeMap;
    }
}
